// extracted by mini-css-extract-plugin
export default {"ChecksStatusBadge":"AsyncChecksStatusBadge-module__ChecksStatusBadge__ujJvO86"};